export default "__VITE_ASSET__4ae7afb4__"